/* eslint-disable @typescript-eslint/no-unused-vars */
import { usePopUpsV2 } from "components/PopUpManagerV2/hooks/usePopUpsV2";
import {
	useEnvContext,
	useGoogleAnalyticsContext,
	useWebStoreContext
} from "contexts";
import { getProfileImageByUserId } from "helpers/getProfileImageByUserId";
import { FriendReferralUsers } from "interfaces";
import { useMemo, useState } from "react";
import { useImagePath } from "hooks/useImagePath";
import { friendCenterAssets } from "assets/cdn";
import { useCreateFriendReferralMutation } from "redux/apis";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import {
	Container,
	CustomButton,
	FriendActivity,
	FriendImage,
	FriendInfo,
	FriendName,
	FriendText
} from "./styles";

interface Props {
	data: FriendReferralUsers | undefined;
}

const FriendItem = ({ data }: Props) => {
	const { open } = usePopUpsV2();
	const { backendUri } = useEnvContext();
	const { getImage } = useImagePath("cdn");
	const profileImage = getImage(friendCenterAssets.common.profileMock);
	const { reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const { userTracker } = useWebStoreContext();
	const { showErrorDialog } = useDialogModalRedux();
	const avatarCacheKey = data?.lastActiveDate;
	const friendImageUrl = getProfileImageByUserId({
		backendUri,
		pictureId: data?.pictureId,
		userId: data?.userId,
		cacheKey: avatarCacheKey
	});
	const [disabled, setDisabled] = useState(false);
	const [createFriendReferral] = useCreateFriendReferralMutation();

	const onClick = () => {
		if (data?.userId && userTracker?.id) {
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "specific_friend_invite_button_click",
				event_type: "friend_list",
				action: "invite_button_click",
				source: "web_friend_referral",
				type: data?.userId
			});
			setDisabled(true);
			createFriendReferral({
				friendUserId: data.userId,
				friendName: data.playerName ?? "Guest"
			})
				.unwrap()
				.then((res) => {
					open({
						variant: "friend-invite-confirm-popup",
						/* id: "friend-invite-confirm-popup",
						replaceIfExists: true, */
						payload: {
							type: data?.userId
						}
					});
				})
				.catch((err) => {
					console.error("Error creating friend referral:", err);
					showErrorDialog(err, {
						isReloadButtonEnabled: true
					});
				});
		}
	};

	const idleText = useMemo(() => {
		if (
			data?.qualificationReason === "dormant" &&
			data?.dormantDaysQualification
		) {
			return `Idle ${data.dormantDaysQualification}+ days`;
		} else {
			return "";
		}
	}, [data?.qualificationReason, data?.dormantDaysQualification]);

	return (
		<Container>
			<FriendInfo>
				<FriendImage
					style={{
						backgroundImage: `url(${friendImageUrl || profileImage})`
					}}
				/>
				<FriendText>
					<FriendName> {data?.playerName || "Guest"} </FriendName>
					<FriendActivity>{idleText}</FriendActivity>
				</FriendText>
			</FriendInfo>
			<CustomButton onClick={onClick} disabled={disabled}>
				Invite
			</CustomButton>
		</Container>
	);
};

export default FriendItem;
